var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { runtime } from '../../Runtime';
export class BrowserAgent {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browser() {
        return runtime.solidPackages.Defer.classes.detectBrowser();
    }
    get browserName() {
        return this.browser.name;
    }
    get browserVersion() {
        return this.browser.version;
    }
    get browserOs() {
        return this.browser.os;
    }
    get isChrome() {
        if (!runtime.availablePackages.Defer)
            return false;
        return this.browser.name === 'chrome';
    }
    get isOldEdge() {
        if (!runtime.availablePackages.Defer)
            return false;
        return this.browser.name === 'edge';
    }
    get isAndroid() {
        return typeof navigator !== 'undefined' && navigator !== null && /android/i.test(navigator.userAgent);
    }
    get isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
}
__decorate([
    memoize
], BrowserAgent.prototype, "browser", null);
